export const BEANIE_CATEGORY_SLUG = "beanie-caps";
